module.exports = __webpack_public_path__ + "gn.svg?1bfbadf5a9b718973177e9d1c408729f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gn.svg
// module id = 1012
// module chunks = 27